<template>
<v-app v-bind:class="{ xsOnly: $vuetify.breakpoint.xsOnly, smAndUp: $vuetify.breakpoint.smAndUp, mdAndUp: $vuetify.breakpoint.mdAndUp  }">
        <div v-if="error" style="">
          <app-alert @dismissed="onDismissed" :text="error.message" :color="error.colour" style="width:100%;"></app-alert>
        </div>
    <v-layout v-show="isLoading"
      align-center
      justify-space-around
      wrap
      fill-height
      style="background:var(--background-grey);"
      >
      <v-progress-circular
          indeterminate
          color="primary"
          :size="50">
      </v-progress-circular>
    </v-layout>
    <div class="loaded-page" v-show="!isLoading">
    <transition name="fade" >
    <div v-if="quote.status === 'Quote sent' && !isStillValid" class="announce-bar text-xs-center">
      <span>
        Hi&nbsp;<strong>{{customerName}}</strong>, this quote from&nbsp;<strong>{{quote.groupTitle}}</strong>&nbsp;has now expired.
      </span>
    </div>
    </transition>
    <transition name="fade" >
    <div v-if="quote.status === 'Quote sent' && isStillValid" class="announce-bar text-xs-center">
      <span>
        Hi&nbsp;<strong>{{customerName}}</strong>, your quote from&nbsp;<strong>{{quote.groupTitle}}</strong>&nbsp;is ready.
      </span>
    </div>
    </transition>
    <transition name="fade" >
    <div v-if="quote.status === 'Accepted'" class="announce-bar paid text-xs-center">
      <span >
        Thank you for accepting quote {{quote.quote_ref}}.
      </span>
    </div>
    </transition>
    <div class="header-area mt-5">
      <div class="header-info">
        <div  v-if="quote.status === 'Quote sent' && isStillValid">
          <v-text-field
          label="Your email"
          v-model="quote.accepted_by_email"
          >
          </v-text-field>
          <v-btn color="primary" block depressed @click="doAcceptQuote()" class="px-5 body-2" style="height:50px;">Accept quote</v-btn>
        </div>
        <div v-if="quote.status === 'Accepted'">
          <span  class="body-2 d-block">Quote accepted:</span>
          <span  class="body-1 d-block">by {{quote.accepted_by_email}}<br>on {{this.formatDateToDateAndMins(quote.accepted_date)}}.</span>
        </div>
      </div>
      <div class="payment-area">
        <a :href='downloadLink'><download-icon class="downloadpdf mt-4" style="fill:#000"></download-icon></a>

      </div>
    </div>
    <div class="invoice-preview mt-5">
      <quote-preview
        :quote="quote"
        :imageUrl="quote.logo"
        :quotedDateFormatted="this.formatDate(quote.quoted_date)"
        :validtoDateFormatted="this.formatDate(quote.validto_date)"
        ></quote-preview>
    </div>

    <p class="body-small text-xs-center mt-3">
          This quote was generated for you by {{quote.groupTitle}} using <a href="https://tryworktabs.com" target="blank">tryworktabs.com</a>
    </p>

    </div>

</v-app>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/database'
import { formatDate } from '@/components/Mixins/formatDate'
import QuotePreview from '@/components/Quote/QuotePreview'
import DownloadIcon from '@/components/Shared/DownloadIcon'
import LockIcon from '@/components/Shared/LockIcon'

export default {
  name: 'quote',
  components: {
    QuotePreview,
    DownloadIcon,
    LockIcon
  },
  mixins: [formatDate],
  data () {
    return {
      itemId: this.$route.params.quote_id,
      groupId: this.$route.params.group_id,
      customerEmail: this.$route.query.e || '',
      customerName: this.$route.query.e || '',
      complete: false,
      quote: {
        id: '',
        title: '',
        clientName: '',
        amount: '',
        contact: '',
        invoice_ref: '',
        invoiced_date: '',
        validto_date: '',
        quote_ref: '',
        paid_date: '',
        chargeTax: false,
        taxRate: '',
        clientAddress: '',
        postCode: '',
        groupTitle: '',
        groupAddress: '',
        logo: '',
        logoWidth: 120,
        logoAlign: 'center',
        paymentTerms: '',
        totalNet: 0,
        totalTax: 0,
        totalGross: 0,
        lineItems: [],
        status: 'Sent',
        payable: false,
        accepted_by_email: this.$route.query.e || ''
      },
      site_url: process.env.VUE_APP_SITEURI,
      loading: 0,
      error: null
    }
  },
  computed: {
    isLoading () {
      if (this.loading > 0) {
        return true
      } else {
        return false
      }
    },
    downloadLink () {
      const cb = Date.now()
      return `${this.site_url}/html2pdf?g=${this.groupId}&i=${this.quote.id}&n=${this.quote.quote_ref}&c=${cb}`
    },
    isStillValid () {
      // checks if the quote is still valid and if so affects areas of the page
      // first of all if no valid to date then it's good to go
      if (!this.quote.validto_date) {
        return true
      }
      // get today and set it to the start of the day
      const today = new Date()
      today.setHours(0, 0, 0, 0)
      // format quotes validto_date as a date object
      const validtoDate = new Date(this.quote.validto_date)
      // Is validtoDate the future? True or False
      return validtoDate > today
    }
  },
  watch: {
    '$route': 'fetchData'
  },
  methods: {
    onDismissed () {
      this.$store.dispatch('clearError')
    },
    addLoading () {
      this.loading++
    },
    subtractLoading () {
      this.loading--
    },
    async fetchData () {
      // check for existing invoice, if so grab all items from this
      try {
        this.addLoading()
        const getCustomerQuote = firebase.functions().httpsCallable('getCustomerQuote')
        const response = await getCustomerQuote({ groupId: this.$route.params.group_id, quoteId: this.$route.params.quote_id })
        this.quote = response.data
        if (this.quote.status !== 'Accepted' && (this.quote.accepted_by_email === '' || this.quote.accepted_by_email === undefined)) {
          this.quote.accepted_by_email = this.customerEmail
        }
        this.subtractLoading()
      } catch (error) {
        this.error = error
        this.subtractLoading()
      }
    },
    async doAcceptQuote () {
      this.addLoading()
      const acceptedByEmail = this.quote.accepted_by_email
      const acceptedByIP = this.quote.accepted_by_email
      try {
        const acceptQuote = firebase.functions().httpsCallable('acceptQuote')
        await acceptQuote({
          groupId: this.$route.params.group_id,
          quoteId: this.$route.params.quote_id,
          acceptedByEmail,
          acceptedByIP
        })
        this.quote.status = 'Accepted'
        this.quote.accepted_by_email = acceptedByEmail
        this.quote.accepted_by_ip = acceptedByIP
        this.quote.accepted_date = Date.now()
        this.subtractLoading()
      } catch (error) {
        this.error = error
        this.subtractLoading()
      }
    },
    async logRead () {
      this.addLoading()
      const readMsg = {
        created: Date.now(),
        status: 'Quote opened',
        by: this.customerEmail
      }
      try {
        const addInvoiceActivity = firebase.functions().httpsCallable('addInvoiceActivity')
        await addInvoiceActivity({ groupId: this.$route.params.group_id, invoiceId: this.$route.params.quote_id, payload: readMsg })
        this.subtractLoading()
      } catch (error) {
        this.error = error
        this.subtractLoading()
      }
    }
  },
  created () {
    this.fetchData()
    this.logRead()
  }
}
</script>

<style lang="scss">
.announce-bar{
  display:flex;
  justify-content: center;
  padding:20px;
  background:blue;
  color:#fff;
  background: linear-gradient(to right, #265698, #248fd5);
  position:absolute;
  top:0;
  left:0%;
  width:100%;
  &.paid{
    background: linear-gradient(to right, #729b3d, #8fd330);
  }
}
.header-area{
  padding-top:55px;
   display:block;
    max-width:95%;
    width:95%;
    margin:0 auto;
    text-align: center;
    .mdAndUp &{
    max-width:1000px;
    width:45vw;
  }
  .mdAndUp &{
    text-align:left;
    display:flex;
    justify-content: space-between;
    align-items:flex-start;
  }
}
.header-info{
  margin-bottom:20px;
  text-align:left;
  display:inline-block;
  margin: 0 auto 20px 0;
  width:100%;
  .mdAndUp &{
    margin-bottom:0px;
    width:50%;
  }
}
.payment-area{
  margin-top: 12px;
    display: inline-block;
    width: 100%;
    .mdAndUp &{
    margin-bottom:0px;
    width:48%;
  }
}
.invoice-preview{
  max-width:95%;
    width:95%;
  margin:0 auto;
  .mdAndUp &{
    max-width:1000px;
    width:45vw;
  }
}
.downloadpdf{
  color:#fff;
  fill: #fff;
}
.downloadpdf:hover{
  // background:var(--light-text);
}
h1{
  width:100%;
  display:block;
}

.btn:not(.btn--flat){
  box-shadow: inset 0 0 0 1px rgba(0, 0, 20, 0.1);
  text-transform:capitalize;
  font-weight:700;
  margin: 10px 0px 6px 8px;
  &.accent{
    background-image: linear-gradient(var(--button-gradient-start-green), var(--green));
  }
  &.error{
    background: var(--red);
  }
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
